import { render } from "./ProfileSection.vue?vue&type=template&id=8add1082"
import script from "./ProfileSection.vue?vue&type=script&lang=js"
export * from "./ProfileSection.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__